// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__wghn3","card":"Cards_card__2a6mg","infected":"Cards_infected__y8NRU","recovered":"Cards_recovered__2QhuJ","deaths":"Cards_deaths__LyKHq"};